import { useState, useEffect, useContext } from "react";
import { getUrl } from 'aws-amplify/storage';
import { Row } from "antd";
import { FileWordOutlined, FileExcelOutlined, FilePdfOutlined, FilePptOutlined, FileOutlined, FileJpgOutlined  } from '@ant-design/icons'
import { AppContext } from "../util/context";

function S3Get(props) {
  const {
    StyledDiv
  } = useContext(AppContext)

  const { image } = props;

  const [extension, setExtension] = useState("");
  const [fileName, setFileName] = useState("");

  useEffect(() => {
    
    getPresignedUrl(image);
  }, [image]);

  async function getPresignedUrl(image) {
    try {
      /* const url = await getUrl({ key: image, options: { level: 'protected'} });
      console.log('Presigned URL fetched:', url.url.href);
      setUrl(url.url.href); */

      const parts = image.split('/');
      const nameAndExtension = parts.pop();
      const extension = nameAndExtension.split('.').pop().toLowerCase();

      const lastUnderscoreIndex = nameAndExtension.lastIndexOf('_');
      let fileName = nameAndExtension;

      if (lastUnderscoreIndex !== -1) {
          fileName = nameAndExtension.substring(0, lastUnderscoreIndex);
      }

      setExtension(extension);
      setFileName(fileName);
    } catch (error) {
      console.log('Error fetching presigned URL:', error);
    }
  }

  /*const handleDownload = () => {
    const link = document.createElement('a');
    link.href = url;
    link.download = props.image;
    link.click();
  };*/

  const handleDownload = async () => {
      const url = await getUrl({ key: image, options: { level: 'protected', expiresIn: 120 } });
      if (!url) return;

      try {
          const response = await fetch(url.url.href);
          const blob = await response.blob();

          const downloadUrl = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = downloadUrl;

          link.download = `${fileName}.${extension}`;
          
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(downloadUrl);
      } catch (error) {
          console.log("Download failed:", error);
      }
  };
  



  return (
    <>
        {/* {url !== "" && (['jpeg', 'png', 'jpg'].includes(extension)) && <>
            {!props.log && <Image width={150} src={url} />}
            {props.log && <Image width={50} src={url} />}
        </>} */}
        {image !== "" && (
            <>
               {!props.log && <Row
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  cursor: "pointer",
                }}
                onClick={handleDownload}
              >
                
                <div style={{cursor: "pointer"}}>
                  {(extension === 'doc' || extension === 'docx') && <FileWordOutlined className="fileLogo"/>}
                  {(extension === 'xls' || extension === 'xlsx') && <FileExcelOutlined className="fileLogo"/>}
                  {(extension === 'pdf') && <FilePdfOutlined className="fileLogo"/>}
                  {(extension === 'ppt' || extension === 'pptx') && <FilePptOutlined className="fileLogo"/>}
                  {(extension === 'jpg' || extension === 'jpeg' || extension === 'png') && <FileJpgOutlined className="fileLogo"/>}
                  {!(
                    extension === 'doc' || 
                    extension === 'docx' || 
                    extension === 'xls' || 
                    extension === 'xlsx' || 
                    extension === 'pdf' || 
                    extension === 'ppt' || 
                    extension === 'pptx' || 
                    extension === 'jpg' || 
                    extension === 'jpeg' || 
                    extension === 'png'
                  ) && <FileOutlined className="fileLogo"/>}
                  
                </div>

                <div
                  style={{
                    marginTop: "10px",
                    fontSize: "12px",
                    width: "100%",
                    overflow: "hidden",
                    whiteSpace: "wrap",
                    color: "#3366CC",
                    fontWeight: "500"
                  }}
                ><StyledDiv>{fileName}.{extension}</StyledDiv></div>
                
              </Row>}

              {props.log && <Row
                style={{
                  display: 'flex',
                  justifyContent: 'start',
                  alignItems: 'center',
                  cursor: "pointer",
                }}
                onClick={handleDownload}
              >
                <div  style={{cursor: "pointer"}}>
                  {(extension === 'doc' || extension === 'docx') && <FileWordOutlined className="fileLogo" style={{
                    fontSize: "30px"
                  }}/>}
                  {(extension === 'xls' || extension === 'xlsx') && <FileExcelOutlined className="fileLogo" style={{
                    fontSize: "30px"
                  }}/>}
                  {(extension === 'pdf') && <FilePdfOutlined className="fileLogo" style={{
                    fontSize: "30px"
                  }}/>}
                  {(extension === 'ppt' || extension === 'pptx') && <FilePptOutlined className="fileLogo" style={{
                    fontSize: "30px"
                  }}/>}
                  {(extension === 'jpg' || extension === 'jpeg' || extension === 'png') && <FileJpgOutlined className="fileLogo" style={{
                    fontSize: "30px"
                  }}/>}
                  {!(
                    extension === 'doc' || 
                    extension === 'docx' || 
                    extension === 'xls' || 
                    extension === 'xlsx' || 
                    extension === 'pdf' || 
                    extension === 'ppt' || 
                    extension === 'pptx' ||
                    extension === 'jpg' ||
                    extension === 'jpeg' ||
                    extension === 'png'
                  ) && <FileOutlined className="fileLogo" style={{
                    fontSize: "30px"
                  }}/>}
                  
                </div>

                <div
                  style={{
                    marginTop: "10px",
                    fontSize: "12px",
                    overflow: "hidden", 
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    fontWeight: "500",
                    color: "#3366CC" // Added blue color to indicate clickability
                  }}
                ><StyledDiv>{fileName}.{extension}</StyledDiv></div>
                
              </Row>}
            </>
            
        )}
    </>
  )
}

export default S3Get;
